export { watchTesteSaga } from './testeSaga';



// WEBPACK FOOTER //
// ./src/features/examples/redux/sagas.js